import ContentLoader from 'react-content-loader';

import styles from './_index.module.scss';

export interface LoaderSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  height?: number;
  width?: number;
}

const LoaderSkeleton = ({ children, height = 300, width = 1333 }: LoaderSkeletonProps) => {
  return (
    <ContentLoader
      backgroundColor="var(--color-surface-light)"
      className={styles['loader-skeleton']}
      data-testid="loader-skeleton"
      foregroundColor="var(--color-surface-medium)"
      height={height}
      width={width}
    >
      {children}
    </ContentLoader>
  );
};

export default LoaderSkeleton;
